import { AutomationCard } from "components/AutomationCard/AutomationCard";
import { AutomationTemplateCard } from "components/AutomationTemplateCard /AutomationTemplateCard ";
import { useGetAutomations } from "hooks/useGetAutomations";
import { useGetChannelConnections } from "hooks/useGetChannelConnections";
import { automationsService } from "services/admin/automationsService";
import { toast } from "react-toastify";
import { AIIcon } from "components/_Icons/AIIcon";
import { FaLink, FaPlus, FaTag } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { Dialog, DialogContent } from "@mui/material";
import { AutomationCreateForm } from "./AutomationCreateForm/AutomationCreateForm";
import { useState } from "react";
import PageGuide from "components/PageGuide/PageGuide";
import { BotVsAgentTable, ReplyOrder } from "components/ReplyModes/ReplyModes";

const templates = [
  {
    id: 1,
    name: "Чат-бот на кодовое слово",
    description: "Новый способ создания автоматизации без конструктора с любого устройства",
    platform: "INSTAGRAM",
    type: "keyword",
    image: <FaTag />,
    templateID: "keyword",
  },
];

export const Automations = () => {
  const { data: automations, refetch } = useGetAutomations();
  const [isCreateAutomationDialogOpen, setIsCreateAutomationDialogOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const navigate = useNavigate();

  const handleDeleteAutomation = async (automationID: string) => {
    console.log("delete automation", automationID);
    try {
      await automationsService.deleteAutomation(automationID);
      toast.success("Автоматизация удалена");
      refetch();
    } catch (error: any) {
      toast.error("Ошибка при удалении автоматизации");
    }
  };

  const onSubmit = async (data: any) => {
    console.log("submit", data);
    setIsCreateAutomationDialogOpen(false);

    if (selectedTemplate?.templateID === "constructor") {
      // Создаем автоматизация с типом constructor
      const createdAutomation = await automationsService.createAutomation({
        name: data.name,
        channelConnectionID: data.channelConnectionID,
        templateID: selectedTemplate.templateID,
      });
      navigate(`/admin/automations/create/constructor/${createdAutomation.id}`);
    } else {
      navigate(
        `/admin/automations/create/${selectedTemplate.templateID}?name=${data.name}&channelConnectionID=${data.channelConnectionID}`
      );
    }
  };

  const onSelectTemplate = (template: any) => {
    setSelectedTemplate(template);
    setIsCreateAutomationDialogOpen(true);
  };

  return (
    <div>
      <div className="mb-8 flex justify-end">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setSelectedTemplate({
              templateID: "constructor",
            });
            setIsCreateAutomationDialogOpen(true);
          }}
          startIcon={<FaPlus size={16} />}
        >
          Создать сценарий
        </Button>
      </div>
      <h1 className="mb-2">Чат-бот (сценарии)</h1>
      <p className="text-gray-600 mb-4">
        Чат-бот отвечает клиентам по заранее написанным сценариям: «если клиент сделал X — бот делает Y».
        Сценарии не тратят ИИ-ответы и работают без ограничений. Сейчас — для Instagram.
      </p>
      <PageGuide id="bot-vs-agent-chatbot" title="Чат-бот или ИИ-агент — в чём разница?">
        <div className="flex flex-col gap-4">
          <BotVsAgentTable />
          <ReplyOrder />
        </div>
      </PageGuide>
      <PageGuide id="automations" title="Как настроить сценарий чат-бота">
        <div className="font-medium mb-1">Что может запустить сценарий (триггер):</div>
        <ul className="list-disc pl-5 mb-2">
          <li><b>Комментарий к публикации</b> с ключевым словом — например «цена» под постом.</li>
          <li><b>Сообщение в директ</b> с ключевым словом.</li>
          <li><b>Распознавание сообщений</b> — ИИ понимает смысл, например «клиент спрашивает о цене».</li>
          <li><b>Любое сообщение</b> в директ.</li>
        </ul>
        <div className="font-medium mb-1">С чего начать:</div>
        <ol className="list-decimal pl-5">
          <li>Подключите Instagram в разделе «Каналы».</li>
          <li>Выберите шаблон <b>«Чат-бот на кодовое слово»</b> ниже, укажите название и канал Instagram.</li>
          <li>Задайте ключевые слова и сообщение, которое бот отправит в директ (можно с кнопками и ссылками).</li>
          <li>Сохраните и проверьте: оставьте комментарий с ключевым словом под своим постом с другого аккаунта.</li>
        </ol>
        <p className="mt-2">«Создать сценарий» открывает конструктор для сценариев из нескольких шагов.</p>
      </PageGuide>
      <section className="mb-8">
        <h3 className="text-2xl font-bold mb-8">Готовые шаблоны</h3>
        {/* Готовые шаблоны */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {templates.map((template) => (
            <AutomationTemplateCard
              key={template.id}
              template={template}
              onSelect={onSelectTemplate}
            />
          ))}
        </div>
      </section>

      {/* Все автоматизации */}
      <section className="mb-8">
        <h3 className="text-2xl font-bold mb-8">Все сценарии</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {automations?.map((automation: any) => (
            <AutomationCard
              key={automation.id}
              automation={automation}
              onDelete={handleDeleteAutomation}
            />
          ))}
        </div>
      </section>

      {/* Dialog for create automation */}
      <Dialog
        open={isCreateAutomationDialogOpen}
        onClose={() => setIsCreateAutomationDialogOpen(false)}
      >
        <DialogContent>
          <AutomationCreateForm onSubmit={onSubmit} />
        </DialogContent>
      </Dialog>
    </div>
  );
};
